export default __webpack_public_path__ + "static/media/avery_dimension.3b4fa6e0.webp";